import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import Swal from "sweetalert2";
import InvestmentChart from "./ScenarioAnalysisChart";
import MFCentralModal from "./modals/MFCentralModal";
import api from "../../../utils/api";
import { formatRupees } from "../../../utils/inputsValidation";
import { FaMinus, FaPlus } from "react-icons/fa";
import socket from "../../../context/socket";
import QRUploadModal from "./modals/QRUploadModal";

const ExternalInvestment = ({
  roomId,
  isChildrens,
  selectedCard,
  setSelectedCard,
  isAccoumulated,
  setisAccoumulated,
  isMonthly,
  setMonthly,
  isDelay,
  isAnnualStepUp,
  isTarget,
  isGetClientGoal,
  setRequiredSIP,
  abcdDAta,
  mapFund,
  unmapFund,
  setAbcdData,
  setMappedItems,
  mappedItems,
  allExternalFolios,
  setAllExternalFolios,
  showMFCentralModal,
  setShowMFCentralModal,
  setShowHealthCheckModal,
  onOpenPortfolioReview,
  getAllExternalFolios,
  onExternalPortfolioImported,
}) => {

  const goalId = selectedCard?._id;
  const goalName = selectedCard?.text;

  const [showQRUpoaderModal, setShowQRUpoaderModal] = useState(false)
  const [isChecked, setIsChecked] = useState(false);
  const [openFolio, setOpenFolio] = useState(null);
  const [openFund, setOpenFund] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false)
  const [accepted, setAccepted] = useState(false)
  const [clientIpAddress, setClientIpAddress] = useState(null)

  const toggleFolio = (i) => setOpenFolio(openFolio === i ? null : i);
  const toggleFund = (i) => setOpenFund(openFund === i ? null : i);

  /* ------------------------------------------------------------------
      MERGE FOLIOS
  ------------------------------------------------------------------ */
  const mergedFolios = allExternalFolios ?? [];

  /* ------------------------------------------------------------------
      CALCULATIONS
  ------------------------------------------------------------------ */
  const calculateFundTotals = (exinvdata) => {
    let totalCost = 0, totalCurrent = 0, totalGain = 0;

    exinvdata.forEach((inv) => {
      totalCost += Number(inv.costValue || 0);
      totalCurrent += Number(inv.currentMktValue || 0);
      totalGain += Number(inv.gainLoss || 0);
    });

    return { totalCost, totalCurrent, totalGain };
  };

  const calculateInvestorTotals = (funds) => {
    let totalCost = 0;
    let totalCurrent = 0;
    let totalGain = 0;

    funds.forEach((fund) => {
      const t = calculateFundTotals(fund.folios);

      totalCost += t.totalCost;
      totalCurrent += t.totalCurrent;
      totalGain += t.totalGain;
    });

    return { totalCost, totalCurrent, totalGain };
  };

  const calculateGroupedFundTotals = (groupedData) => {
    let totalCost = 0;
    let totalCurrent = 0;
    let totalGain = 0;

    groupedData.forEach((inv) => {
      totalCost += Number(inv.costValue || 0);
      totalCurrent += Number(inv.currentMktValue || 0);
      totalGain += Number(inv.gainLoss || 0);
    });

    return {
      totalCost,
      totalCurrent,
      totalGain,
    };
  };

  /* ------------------------------------------------------------------
      API FETCH + SOCKET PUSH
  ------------------------------------------------------------------ */
  // useEffect(() => {
  //   if (!roomId) return;

  //   // const fetchFolios = async () => {
  //   //   await handleExternalInvestmentsClick();
  //   // };

  //   // fetchFolios();
  //   console.log("Live folio sended:", allExternalFolios);
  //   // Advisor joins a room
  //   socket.emit("gateway", { room: roomId, message: allExternalFolios });

  //   return () => {
  //     socket.emit("gateway", roomId);
  //   };
  // }, [roomId,]);

  useEffect(() => {
    if (!roomId || !allExternalFolios) return;
    socket.emit("join", { room: roomId });
    socket.emit("externalInvData", { room: roomId, message: allExternalFolios });
  }, [allExternalFolios, roomId]);


  const getAllExternalFoliosAdvisor = async () => {
    try {
      Swal.fire({
        text: "Loading external folios...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const response = await api.post(`advisor/getAllExternalFolios`, {
        clientId: roomId,
      });

      Swal.close();
      const folios = response.data ?? [];
      setAllExternalFolios(folios);

      // 🔥 Send data live to client
      // socket.emit("execute", { room: roomId, message: folios });
      socket.emit("externalInvData", { room: roomId, message: folios });
      console.log("Liveexecute1:", folios);


    } catch (error) {
      Swal.close();
      Swal.fire("Error", "Unable to load data.", "error");
    }
  };

  /* ------------------------------------------------------------------
      MAPPING LOGIC
  ------------------------------------------------------------------ */
  const isMappedFolio = (inv) =>
    inv.goal_name ||
    inv.sub_goal_name ||
    ["66d0280c9a75443e96fd3411", "66d028759a75443e96fd3412"].includes(inv.goal_id);

  const isMappedToCurrentGoal = (inv) => {
    const isChildGoal = [
      "66d0280c9a75443e96fd3411",
      "66d028759a75443e96fd3412",
    ].includes(goalId);

    if (isChildGoal) {
      return inv.sub_goal_id === selectedCard?.action_data?.[0]?._id;
    }

    return inv.goal_id === goalId;
  };

  const mapFolio = async (mktValue, id, investment) => {
    mapFund({ currentValue: Number(mktValue), folioNumber: id });

    try {
      let payload = {
        mfcentral_id: id,
        client_id: roomId,
        goal_name: goalName,
        goal_id: goalId,
        status: 1,
      };

      // CHILD GOAL CASE
      if (
        ["66d0280c9a75443e96fd3411", "66d028759a75443e96fd3412"].includes(goalId)
      ) {
        payload.sub_id = selectedCard?.action_data?.[0]?._id;
        payload.sub_name = selectedCard?.action_data?.[0]?.goalText || goalName;
      }

      await api.post(`advisor/map_goal_mfcentral`, payload);

      // REFRESH DATA
      await getAllExternalFoliosAdvisor();

      // 🔥 Notify client in real-time
      socket.emit("join", roomId);
      socket.emit("advisor_mapped_update", {
        room: roomId,
        data: {
          folioId: id,
          goalName,
          goalId
        }
      });



    } catch (e) {
      console.error(e);
    }
  };


  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const unmapFolio = async (mktValue, id, investment) => {
    unmapFund({ currentValue: Number(mktValue), folioNumber: id });

    try {
      let payload = {
        mfcentral_id: id,
        client_id: roomId,
        goal_name: goalName,
        goal_id: goalId,
        status: 0,
      };

      if (
        ["66d0280c9a75443e96fd3411", "66d028759a75443e96fd3412"].includes(goalId)
      ) {
        payload.sub_id = selectedCard?.action_data?.[0]?._id;
        payload.sub_name = investment.goal_name || "";
      }

      await api.post(`advisor/map_goal_mfcentral`, payload);

      await getAllExternalFoliosAdvisor();
      // 🔥 Notify client
      socket.emit("join", roomId);
      socket.emit("advisor_mapped_update", {
        room: roomId,
        data: {
          folioId: id,
          goalName,
          goalId
        }
      });

    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!roomId) return;

    socket.emit("join", { room: roomId });
    const handleMessage = (msg) => {
      console.log("msg", msg)
      if (msg.data.location === "mf_central_redirect_url_client") {
        const url = msg.data.url;

        window.open(
          url,
          "_blank",
          "width=600,height=700,top=100,left=100,resizable=yes,scrollbars=yes"
        );

        setShowQRUpoaderModal(true);
        setShowMFCentralModal(false)
      }
      if (msg.data.location === "show_accept_button_client") {
        setAccepted(msg.data.isAccepted)
        setClientIpAddress(msg.data.currentIP)
      }
    };

    socket.on("message_to", handleMessage);

    return () => {
      socket.off("message_to", handleMessage);
    };
  }, [roomId]);

  useEffect(() => {
    // if (isConfirmed) {
    socket.emit("message_to", {
      room: roomId,
      data: {
        location: "show_accept_button",
        isConfirmed: isConfirmed
      },
    })
    // }
  }, [isConfirmed])


  /* ------------------------------------------------------------------
      RENDER
  ------------------------------------------------------------------ */
  return (
    <>



      {/* TABLES SAME AS YOUR VERSION */}
      {/* ———————————————— */}
      {/* FULL RENDER CODE UNTOUCHED */}
      {/* ———————————————— */}

      {/* EVERYTHING BELOW IS SAME AS YOUR EXISTING UI CODE */}
      {/* I DID NOT CHANGE UI AT ALL */}
      {/* Only logic updated above */}

      <div className="row">
        <div className="col">
          <div className="scroll-container">

            {/* DESKTOP TABLE */}
            {mergedFolios.length !== 0 && (
              <>
                <table className="table d-md-block d-none">
                  <thead className="sticky-header table-light">
                    <tr>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">Folio Number</th>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">Scheme Name</th>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">Invested Through</th>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">NAV</th>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">Cost Value</th>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">Current Value</th>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">Gain/Loss</th>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">Mapped To</th>
                      <th scope="col" className="back-clrgreen txt-color-revers sticky-header">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {mergedFolios.map((investor, i) => {
                      const investorTotals = calculateInvestorTotals(investor.exinvdata);

                      return (
                        <React.Fragment key={i}>
                          <tr>
                            <td colSpan="9" className="fw-bold fs-5 py-2">
                              {investor.investorName}
                            </td>
                          </tr>

                          {investor.exinvdata.map((fund, fIndex) => {
                            const fundTotals = calculateFundTotals(fund.folios);
                            return (
                              <React.Fragment key={fIndex}>
                                <tr>
                                  <td colSpan="9" className="fw-semibold">
                                    Fund: {fund.fundName}
                                  </td>
                                </tr>

                                {/* {Object.entries(fund.exinvdata).map(([investorName, investments]) => { */}


                                {/* Investments */}
                                {
                                  fund.folios.map((inv, idx) => (
                                    <tr key={idx}>
                                      <td>{inv.folio}</td>
                                      <td>{inv.schemeName}</td>
                                      <td>{inv.brokerName}</td>
                                      <td>{inv.nav}</td>
                                      <td>{formatRupees(inv.costValue)}</td>
                                      <td>{formatRupees(inv.currentMktValue)}</td>
                                      {/* <td>{formatRupees(inv.gainLoss)}</td> */}
                                      <td>{formatRupees(Number(inv.currentMktValue) - Number(inv.costValue))}</td>

                                      <td>
                                        {[
                                          "66d0280c9a75443e96fd3411",
                                          "66d028759a75443e96fd3412",
                                        ].includes(inv.goal_id)
                                          ? inv.sub_goal_name || "—"
                                          : inv.goal_name || "—"}
                                      </td>

                                      <td>
                                        <Dropdown>
                                          <Dropdown.Toggle
                                            variant="success"
                                            disabled={
                                              inv.goal_name &&
                                              inv.goal_name !== selectedCard?.text
                                            }
                                          >
                                            Action
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <Dropdown.Item
                                              onClick={() =>
                                                mapFolio(inv.currentMktValue, inv._id, inv)
                                              }
                                              disabled={isMappedFolio(inv)}
                                            >
                                              Map
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                              onClick={() =>
                                                unmapFolio(inv.currentMktValue, inv._id, inv)
                                              }
                                              disabled={!isMappedToCurrentGoal(inv)}
                                            >
                                              Unmap
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </td>
                                    </tr>
                                  ))
                                }

                                {/* Fund Total for this Investor */}
                                <tr>
                                  <td></td>
                                  <td colSpan="2" className="fw-bold">
                                    Fund Total
                                  </td>
                                  <td></td>
                                  <td>{fundTotals.totalCost.toFixed(2)}</td>
                                  <td>{fundTotals.totalCurrent.toFixed(2)}</td>
                                  {/* <td>{fundTotals.totalGain.toFixed(2)}</td> */}
                                  <td>
                                    {(
                                      (Number(fundTotals.totalCurrent) || 0) -
                                      (Number(fundTotals.totalCost) || 0)
                                    ).toFixed(2)}
                                  </td>
                                  <td colSpan="2"></td>
                                </tr>
                              </React.Fragment>
                            );
                            {/* })} */ }

                          })}

                          {/* INVESTOR GRAND TOTAL */}
                          <tr>
                            <td></td>
                            <td colSpan="2" className="fw-bold clrgreen">
                              Grand Total
                            </td>
                            <td></td>
                            <td className="fw-bold clrgreen">
                              {investorTotals.totalCost.toFixed(2)}
                            </td>
                            <td className="fw-bold clrgreen">
                              {investorTotals.totalCurrent.toFixed(2)}
                            </td>
                            <td className="fw-bold clrgreen">
                              {(
                                (Number(investorTotals.totalCurrent) || 0) -
                                (Number(investorTotals.totalCost) || 0)
                              ).toFixed(2)}
                            </td>
                            <td colSpan={2}></td>
                          </tr>

                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>


              </>
            )}


            {/* -------------------------------------------------------------------- */}
            {/*                      MOBILE ACCORDION VERSION                         */}
            {/* -------------------------------------------------------------------- */}

            <div className="d-md-none d-block px-2">

              {mergedFolios.map((investor, i) => {
                const investorTotals = calculateInvestorTotals(investor.exinvdata);

                return (
                  <div key={i} className="mb-3">

                    {/* INVESTOR LEVEL */}
                    <div
                      className="card p-3 back-clrgreen txt-color-revers d-flex justify-content-between flex-row"
                      onClick={() => toggleFolio(i)}
                    >
                      <strong>{investor.investorName}</strong>

                      {openFolio === i ? (
                        <FaMinus className="txt-color-revers" />
                      ) : (
                        <FaPlus className="txt-color-revers" />
                      )}
                    </div>

                    {/* FUND LEVEL */}
                    {openFolio === i && (
                      <div className="mt-2">

                        {investor.exinvdata.map((fund, fIndex) => {
                          const fundTotals = calculateGroupedFundTotals(fund.folios);

                          return (
                            <div key={fIndex} className="mb-2">

                              {/* FUND TITLE */}
                              <div
                                className="card p-2 d-flex justify-content-between flex-row"
                                onClick={() => toggleFund(fIndex)}
                              >
                                <span>Fund: {fund.fundName}</span>

                                {openFund === fIndex ? (
                                  <FaMinus className="clrgreen" />
                                ) : (
                                  <FaPlus className="clrgreen" />
                                )}
                              </div>

                              {/* INVESTMENT LIST */}
                              {openFund === fIndex && (
                                <div className="mt-2">
                                  {fund.folios.map((inv, index) => (
                                    <div key={index} className="card p-3 mb-2">
                                      <div className="d-flex justify-content-between">
                                        <strong>Folio:</strong>
                                        <span>{inv.folio}</span>
                                      </div>

                                      <div className="d-flex justify-content-between text-end">
                                        <strong>Scheme:</strong>
                                        <span>{inv.schemeName}</span>
                                      </div>

                                      <div className="d-flex justify-content-between text-end">
                                        <strong>Broker:</strong>
                                        <span>{inv.brokerName}</span>
                                      </div>

                                      <div className="d-flex justify-content-between">
                                        <strong>NAV:</strong>
                                        <span>{inv.nav}</span>
                                      </div>

                                      <div className="d-flex justify-content-between">
                                        <strong>Cost:</strong>
                                        <span>{inv.costValue}</span>
                                      </div>

                                      <div className="d-flex justify-content-between">
                                        <strong>Current:</strong>
                                        <span>{inv.currentMktValue}</span>
                                      </div>

                                      <div className="d-flex justify-content-between">
                                        <strong>Gain/Loss:</strong>
                                        <span>{inv.gainLoss}</span>
                                      </div>
                                      <div className="d-flex justify-content-between">
                                        <strong>Mapped to:</strong>
                                        <span>{inv.goal_name || '--'}</span>
                                      </div>

                                      <div className="d-flex justify-content-between">
                                        <strong>Action:</strong>
                                        <span><Dropdown>
                                          <Dropdown.Toggle
                                            variant="success"
                                            disabled={
                                              inv.goal_name &&
                                              inv.goal_name !== selectedCard?.text
                                            }
                                          >
                                            Action
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <Dropdown.Item
                                              onClick={() =>
                                                mapFolio(inv.currentMktValue, inv._id, inv)
                                              }
                                              disabled={isMappedFolio(inv)}
                                            >
                                              Map
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                              onClick={() =>
                                                unmapFolio(inv.currentMktValue, inv._id, inv)
                                              }
                                              disabled={!isMappedToCurrentGoal(inv)}
                                            >
                                              Unmap
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown></span>
                                      </div>


                                    </div>
                                  ))}

                                  {/* FUND TOTAL */}
                                  <div className="card p-3 mt-2 mb-3">
                                    <strong>Fund Total</strong>
                                    <div className="d-flex justify-content-between">
                                      <span>Cost:</span>
                                      <span>{fundTotals.totalCost.toFixed(2)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                      <span>Current:</span>
                                      <span>{fundTotals.totalCurrent.toFixed(2)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                      <span>Gain:</span>
                                      <span>{fundTotals.totalGain.toFixed(2)}</span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}



                      </div>
                    )}
                    {/* INVESTOR GRAND TOTAL */}
                    <div className="card p-3 mt-2">
                      <strong className="mb-2">Grand Total</strong>

                      <div className="d-flex justify-content-between">
                        <span>Cost:</span>
                        <span>{investorTotals.totalCost.toFixed(2)}</span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>Current:</span>
                        <span>{investorTotals.totalCurrent.toFixed(2)}</span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>Gain:</span>
                        <span>{investorTotals.totalGain.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                );
              })}

            </div>




          </div>
          {(mergedFolios.length !== 0) && (
            <div className="d-flex align-items-center ">

              <input
                type="checkbox"
                className="form-check-input me-2 mt-1"
                checked={isConfirmed}
                onChange={(e) => setIsConfirmed(e.target.checked)}
              />

              <p className="fw-bold mb-0">
                Request consent for ARN Transfer
              </p>

            </div>
          )}
          {
            isConfirmed && (
              <div className="d-flex align-items-center gap-2 mt-4">
                <button
                  className="btnactive upercase float-end text-white"
                  style={{ width: "100px", height: "40px", fontSize: "14px" }}
                  id="pushToArchive"
                // onClick={() => setShowMFCentralModal(true)}
                >
                  {accepted ? "Accepted" : "Accept"}
                </button>

                {/* <p className="fw-bold mb-0">
                  I provide my consent for an ARN Transfer to FinEdge.
                </p> */}
                {accepted &&
                  <p className="fw-bold mb-0">
                    Ip Address: {clientIpAddress}
                  </p>
                }
              </div>
            )
          }
          {mergedFolios.length !== 0 && (
            <button
              className="btnactive upercase mt-4 float-end text-white ms-2"
              id="pushToArchive"
              onClick={() => {
                if (onOpenPortfolioReview) {
                  onOpenPortfolioReview();
                } else if (setShowHealthCheckModal) {
                  setShowHealthCheckModal(true);
                } else {
                  setShowMFCentralModal(true);
                }
              }}
            >
              Add Investments
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ExternalInvestment;

